import React, { useEffect, useState } from 'react';
import notify from '../../utils/notify';
import '../../component-styles/NotificationCenter.css';

function NotificationCenter() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const unsubscribe = notify.subscribe((payload) => {
      setItems((prev) => [...prev, payload]);
      const timeout = payload.duration > 0 ? payload.duration : 4200;
      setTimeout(() => {
        setItems((prev) => prev.filter((item) => item.id !== payload.id));
      }, timeout);
    });

    return unsubscribe;
  }, []);

  return (
    <div className="notification-center" aria-live="polite" aria-atomic="false">
      {items.map((item) => (
        <div
          key={item.id}
          className={`notification-toast notification-toast--${item.type || 'info'}`}
          role="status"
        >
          <div className="notification-toast__message">{item.message}</div>
        </div>
      ))}
    </div>
  );
}

export default NotificationCenter;
